<form
  class="row-form"
  [formGroup]="marketingBlockFormGroup()"
>
  @for (field of marketingBlockFormFields; track $index) {
    @switch (field.fieldName) {
      @case ('title') {
        <mat-form-field
          appearance="outline"
          class="row-form-field"
          [class]="getFormFieldClass()"
        >
          <mat-label>
            {{ field.label }}
          </mat-label>
          <input
            matInput
            [formControlName]="field.fieldName"
            (blur)="handleValueChange(field.fieldName)"
          >
        </mat-form-field>
      }
      @case ('comment') {
        @if (isActiveEditor()) {
          <mat-form-field
            appearance="outline"
            class="row-form-field"
            [class]="getFormFieldClass()"
          >
            <mat-label>{{ field.label }}</mat-label>
            <textarea
              matInput
              cdkTextareaAutosize
              type="text"
              cdkAutosizeMinRows="7"
              cdkAutosizeMaxRows="7"
              [formControlName]="field.fieldName"
              (blur)="handleValueChange(field.fieldName)"
            ></textarea>
          </mat-form-field>
        }
      }
    }
  }
</form>
@if (!isActiveEditor()) {
  <div class="row-buttons">
    @if (!marketingBlockData().id) {
      @if (noFirstData()) {
        <button
          mat-icon-button
          class="row-btn"
          (click)="handleClick('delete')"
        >
          <mat-icon class="row-btn-icon">delete</mat-icon>
        </button>
      }
      <button
        mat-icon-button
        class="row-btn"
        [disabled]="!marketingBlockFormGroup().valid"
        (click)="handleClick('save')"
      >
        <mat-icon class="row-btn-icon">save</mat-icon>
      </button>
    } @else {
      <button
        mat-icon-button
        class="row-btn"
        (click)="handleClick('openModal')"
      >
        <mat-icon class="row-btn-icon">description</mat-icon>
      </button>
      <button
        mat-icon-button
        class="row-btn"
        (click)="handleClick('history')"
      >
        <mat-icon class="row-btn-icon">info</mat-icon>
      </button>
      @if (isEditModeActive()) {
        <button
          mat-icon-button
          class="row-btn"
          (click)="handleClick('deleteCurrent')"
        >
          <mat-icon class="row-btn-icon">delete</mat-icon>
        </button>
      }
    }
  </div>
}
